<template>
  <div class="flex">
    <div class="lp-active-title">{{ label }}</div>
    <lp-adm-drop-input @onSelect="onSelect"
                       :selectVal="per"
                       :data.sync="percentArr"
                       width="80px"
                       listAlign="center"></lp-adm-drop-input>
    <div class="lp-active-count">{{ unit }}</div>
  </div>
</template>

<script>
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import LpCheckGroup from "../../module/common/LpCheckGroup";
  import LpCheckGroupBoolean from "../../module/common/LpCheckGroupBoolean";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";

  export default {
    props: [ 'label', 'percent', 'unit' ],
    components: {
      LpAdmDropInput,
      LpCheckGroupBoolean,
      LpCheckGroup,
      AdminBoxItem},
    watch: {
      percent(n) {
        this.per = n;
      }
    },
    data () {
      return {
        per: 0,
        percentArr: []
      }
    },
    created() {

      if(this.percent > 0) {
        this.per = this.percent;
      }
      this.initPercent();
    },
    methods: {
      // 퍼센티지 배열에 값 넣기
      initPercent() {
        let percentArr = []
        for(let i=0; i<=20; i++) {
          percentArr.push({ label: (i*5).toString(), value: i*5 });
        }
        this.percentArr = percentArr;
      },
      onSelect(res) {
        this.per = res.value;
        this.$emit('update:percent', res.value);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .lp-active-title
    font-size 0.9rem
    margin-top 6px
    margin-right 15px

  .lp-active-count
    font-size 0.9rem
    margin-top 6px
    margin-left 15px

</style>
